import { useSelector } from 'react-redux';
import {
  selectAppUser,
  selectIsLoggedIn,
  selectIsUserLoading,
  selectUser,
} from '@/lib/redux/app.selectors';

const useUser = () => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const user = useSelector(selectUser);
  const appUser = useSelector(selectAppUser);
  const isLoading = useSelector(selectIsUserLoading);

  return {
    isLoggedIn,
    user,
    appUser,
    isLoading,
  };
};

export default useUser;
